var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessagereplytextoutline1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-reply-text-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.50581 10.6736H19.0105V12.6143H9.50581V10.6736ZM19.0105 6.79221H6.33758V8.73292H19.0105V6.79221ZM23.2348 3.88114V21.3475L19.0105 17.4661H4.22543C3.06375 17.4661 2.11328 16.6025 2.11328 15.5254V3.88114C2.11328 2.81375 3.06375 1.94043 4.22543 1.94043H21.1226C22.2843 1.94043 23.2348 2.80405 23.2348 3.88114ZM21.1226 3.88114H4.22543V15.5254H19.887L21.1226 16.6607V3.88114Z",
    fill: "#E35205"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagereplytextoutline1);
export default __webpack_public_path__ + "static/media/messagereplytextoutline1.3cfa18634c597618e2de07b861a73d71.svg";
export { ForwardRef as ReactComponent };